import { Logo, LogoIconWhiteSynapse } from '@/components';
import { SsoModal } from '@/features/auth/SsoModal';

import { type VariantSettings } from './variantConfiguration';

export const synapsConfig: VariantSettings = {
  WebsiteName: 'Synaps AI',
  Logo: <Logo />,
  LogoIconWhite: (
    <LogoIconWhiteSynapse color="gray.900" fontSize={36} boxSize={9} />
  ),
  SsoModal: <SsoModal />,
};
